import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import dayjs from 'dayjs';
import type { GetAllRefereesStatus } from './types';
import { checkInvalidDate } from '../../ApplicationForm';

const GET_ALL_REFEREE_STATUS = gql`
  query ($applicationId: ID!) {
    queryRefereeForm(applicationId: $applicationId) {
      refereeReportStatus {
        deadline
        academicRefereeId
        nameOfReferee
        email
        status
        repliedAt
        lastSentDate
        canResendEmail
        canUpdateEmail
      }
    }
  }
`;

export const useQueryAllRefereeStatus = (
  applicationId: string,
): GetAllRefereesStatus => {
  const { data, loading, error, refetch } = useQuery(GET_ALL_REFEREE_STATUS, {
    variables: {
      applicationId,
    },
  });

  const refereeReportStatus = (
    data?.queryRefereeForm.refereeReportStatus ?? []
  ).map((referee: any) => ({
    academicRefereeId: referee?.academicRefereeId ?? '',
    nameOfReferee: referee?.nameOfReferee ?? '',
    email: referee?.email ?? '',
    status: referee?.status ?? '',
    repliedAt: checkInvalidDate(referee?.repliedAt)
      ? '-'
      : dayjs(referee?.repliedAt).format('DD/MM/YYYY'),
    lastSentDate: checkInvalidDate(referee?.lastSentDate)
      ? '-'
      : dayjs(referee?.lastSentDate).format('DD/MM/YYYY'),
    deadline: checkInvalidDate(referee?.deadline)
      ? '-'
      : dayjs(referee?.deadline).format('DD/MM/YYYY'),
    canResendEmail: referee?.canResendEmail ?? false,
    canUpdateEmail: referee?.canUpdateEmail ?? false,
  }));

  return {
    refereeReportStatus,
    loading,
    error,
    refetch,
  };
};
